'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifySubtitle = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var stringifySubtitle = exports.stringifySubtitle = R.pipe(R.map(function (_ref) {
  var header = _ref.header,
      label = _ref.label;
  return R.isNil(header) ? label : header + ' ' + label;
}), R.join(' · '));